import { Component, Inject, OnInit } from '@angular/core';
import * as XLSX from 'xlsx';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  templateUrl: './gstreport.component.html',
  styleUrls: ['./gstreport.component.scss']
})
export class GSTReportComponent implements OnInit {

  receiptledger: any[] = [];
  total_amt: number = 0;
  startdate: any;
  enddate: any;

  fileName = 'GST_ExcelSheet.xlsx';

  constructor(
    private dialogref: MatDialogRef<GSTReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.receiptledger = this.data['val'] || [];
    this.total_amt = this.data['totalamt'] || 0;
    this.startdate = this.data['startdate'];
    this.enddate = this.data['enddate'];

    console.log(this.receiptledger);
  }

  // ================= EXPORT EXCEL =================
  exportexcel(): void {

  const exportData = this.receiptledger.map((item, index) => ({
    'Sr. No.': index + 1,

    'Receipt Date': item.receipt_date
      ? new Date(item.receipt_date).toLocaleDateString('en-GB')
      : '',

    'Book Seller Name': item.book_seller_name_eng || '',

    'Address': item.edistrict || '',

    'Receipt No': item.receipt_no || '',

    'GST No': '27AAATH0433Q1ZI',

    'HSN': '4902',

    'Total Amount': item.select_entry_amt || 0
  }));

  const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);

  // Optional: column width improvement (recommended)
  ws['!cols'] = [
    { wch: 8 },   // Sr No
    { wch: 15 },  // Receipt Date
    { wch: 30 },  // Book Seller Name
    { wch: 25 },  // Address
    { wch: 15 },  // Receipt No
    { wch: 15 },  // GST No
    { wch: 10 },  // HSN
    { wch: 15 }   // Total Amount
  ];

  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'GST Report');

  XLSX.writeFile(wb, this.fileName);
}
}